import React from 'react';
import { BabyNamesArticleHeading, ProductContainer } from './styled';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import Card from '../../Parenting/ArticlesAndVideos/Card';
import { t } from '../../../Utils/CommonUtils/translate';
import { images } from '../../../Constants/ImageUrls';

export default React.memo(function BabyNamesArticle(props) {
  let { articleData, lang } = props;
  return (
    <div>
      <ProductContainer>
        <BabyNamesArticleHeading>
          {t('Unable to choose? Read these articles')}
        </BabyNamesArticleHeading>
        <AnywhereHorizontalScroll
          firstElementId={`${0}first`}
          lastElementId={`${articleData?.length - 1}last`}
          leftArrow={
            <img
              src={images.arrowDownForward}
              alt="left arrow"
              loading="lazy"
            />
          }
          rightArrow={
            <img
              src={images.arrowDownForward}
              alt="right arrow"
              loading="lazy"
            />
          }
          scrolledWidth={440}
          nomWebScroll={true}
        >
          {articleData?.map((data, index) => {
            return (
              <Card
                primaryTagId={data?.primary_tag_id}
                index={index}
                cardData={data?.content}
                contentType={data?.content_type}
                heading={`Articles (${articleData?.length})`}
                key={index}
                allData={data}
                babyNamesArticle={true}
                id={
                  index == 0
                    ? `${0}first`
                    : index == articleData?.length - 1
                      ? `${articleData?.length - 1}last`
                      : `searchproductCards${index}`
                }
                lang={lang}
                // parentTag={parentTag}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </ProductContainer>
    </div>
  );
});
